module.exports = __webpack_public_path__ + "static/media/static-es.4781f603.png";